<template>
    <b-container class="listing shadow mx-auto bg-white rounded p-3 mt-5 container">
        <b-breadcrumb class="bg-white" :items="this.breadcrumb_items"></b-breadcrumb>
        <b-row>
            <b-col class="col-md-8 offset-md-2">
                <h4 class="text-center">{{ listingLocal.UnparsedAddress }}</h4>
                <lingallery :responsive="true" :items="this.image_array"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-md-6 offset-md-2 mb-3 mt-3">
                <div class="icon-group">
                    <a href="#map" style="color:black"><i
                        class="fas fa-map-marker-alt fa-2x"></i>&nbsp;View On Map</a>
                    <i class="fas fa-calculator fa-2x" @click="calculatorShow"></i> ${{ this.estimated_cost }} Estimated
                    Monthly*
                </div>
            </b-col>
            <b-col class="col-md-2 p-2 mb-5 mb-3 mt-3 border rounded shadow text-center col">
                <div class="icon-group">
                    <a target="_blank" @click="facebookShare">
                        <i style="color:#4267b2" class="fab fa-facebook-f fa-2x" aria-hidden="true"
                           v-b-tooltip.hover title="share to facebook"></i>
                    </a>
                    <a :href=mailString><i class="far fa-envelope fa-2x p-2" style="color:black" v-b-tooltip.hover
                                           title="share via email"></i></a>
                    <i v-b-tooltip.hover
                       v-bind:title="[this.isFavorite ? this.unfavorite_tooltip : this.favorite_tooltip]"
                       v-bind:class="[this.isFavorite ? 'fas fa-heart fa-2x' : 'far fa-heart fa-2x']"
                       style="color:red" @click="setAsFavorite()"></i>
                </div>
            </b-col>
            <hr>
        </b-row>
        <b-row>
            <b-col cols="12" class="text-center">
                <div v-if="this.listingLocal.openHouses">
                    <!--                    <div v-for="openHouse in this.listingLocal.openHouses">-->
                    <b-alert show><i class="fas fa-door-open fa-lg"></i>
                        Next Open House: {{ this.listingLocal.openHouses.Date }} from
                        {{ this.listingLocal.openHouses.StartTime }} to {{ this.listingLocal.openHouses.EndTime }}
                    </b-alert>
                    <!--                    </div>-->
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" class="mt-5">
                <p>{{ listingLocal.PublicRemarks }}</p>
            </b-col>
        </b-row>

        <b-row class="mb-2">
            <b-col cols="12" sm="6">
                <b-table class="listing-table"
                         stacked
                         bordered
                         border-variant="light"
                         :items="computedFields">
                </b-table>
            </b-col>
            <b-col cols="12" sm="6">
                <b-card
                    border-variant="light"
                    class="border-3">
                    <h4 class="force-center">
                        {{ card_title }}
                    </h4>
                    <h6 class="muted force-center">
                        {{ subtitle }}
                    </h6>
                    <hr>
                    <div class="top-left" v-if="this.listingLocal.agent">
                        <b-img class="rounded-circle img-fluid d-block mx-auto" :src="this.listingLocal.agent.image_url !== null ? this.listingLocal.agent.image_url + '?fit=facearea&facepad=6&w=75&h=75' :
                                'http://forman-realty-group.imgix.net/no_image_available.jpg?fit=facearea&facepad=6&w=75&h=75'"></b-img>
                    </div>
                    <contact-us :placeholder_text="placeholder"></contact-us>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <div id="map">
                    <GmapMap
                        :center="{lat: this.listingLocal.Latitude, lng: this.listingLocal.Longitude}"
                        :zoom="15"
                        map-type-id="terrain"
                        style="width: 100%; height: 300px">
                        <GmapMarker
                            :key="index"
                            v-for="(m, index) in markers"
                            :position="m.position"
                            :clickable="true"
                            :draggable="true"
                            @click="center=m.position"/>
                    </GmapMap>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="col-md-8 offset-md-2 text-muted text-center">
                    This listing provided courtesy of {{ this.listingLocal.ListOfficeName }}
                </div>
            </b-col>
        </b-row>
        <b-modal id="calculatorModal" ref="calculatorModal" title="Mortgage Calculator" size="lg">
            <calculator :homeValue="this.listingLocal.CurrentPrice" ref="calculator"></calculator>
            <div slot="modal-footer" class="w-100"></div>
        </b-modal>
    </b-container>
</template>

<script>
import {Carousel, Slide} from 'vue-carousel';
import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'

export default {

    name: 'listing',
    components: {
        // Calculator,
        Carousel,
        Slide,
        VueImageLightboxCarousel,
    },
    props: {
        name: {
            type: String
        },
    },
    created() {
        this.getListing();
    },
    data() {
        return {
            listingLocal: null,
            breadcrumb_items: [
                {
                    text: 'Home',
                    href: '/'
                },
                {
                    text: 'All Listings',
                    href: '/browse'
                },
            ],
            width: 800,
            height: 400,
            isFavorite: false,
            favorite_tooltip: "Save this Listing",
            unfavorite_tooltip: "Unsave this Listing",
            showLightbox: false,
            mailString: "",
            markers: [],
            place: null,
        }
    },
    methods: {
        openLightbox() {
            this.showLightbox = true;
            this.$refs.lightbox.showImage(1);
        },
        changeImage(index) {
            // console.log(index)
        },
        getListing() {
            let _self = this;
            _self.isLoading = true;

            let route = '/api/listing/' + this.$route.params.listingId;

            let promise = axios.get(route);

            return promise.then((response) => {
                _self.isLoading = false;

                if (typeof response.data !== 'undefined') {
                    _self.listingLocal = response.data.listing;

                    this.breadcrumb_items.push({
                        'text': response.data.listing.UnparsedAddress.substr(0, response.data.listing.UnparsedAddress.indexOf(',')),
                        'href': "#",
                        'active': true
                    })
                }
            });
        },
        calculatorShow() {
            this.$refs['calculatorModal'].show();
        },
        setAsFavorite() {
            let _self = this;

            let data = {
                user_id: this.$userId,
                listing_id: _self.listingLocal.ListingKey,
                listing_address: _self.listingLocal.UnparsedAddress
            };

            let route = _self.listingLocal.isFavorite ? '/api/favorites/delete' : '/api/favorites';
            _self.isFavorite = !_self.isFavorite;

            axios.post(route, data)
                .then(function (response) {
                    if (response.data.status === false) {
                        _self.toast("We're very sorry but there has been an error. Please try again later.", 'danger');
                    } else {
                        if (!_self.isFavorite) {
                            _self.toast('Listing status saved!', 'success', "Listing Unfavorited");
                        } else {
                            _self.toast('Listing status saved!', 'success', "Listing Favorited!");
                        }
                    }
                });
        },
        toast(message, variant, title = null) {
            this.$bvToast.toast(message, {
                title: title,
                variant: variant,
                solid: true
            })
        },
        mail_sent() {
            this.toast('Message Sent!', 'success');
        },
        formatCurrency(variable) {
            return '$' + new Intl.NumberFormat().format(variable);
        },
        formatNA(variable) {
            if (variable === '********') {
                return "N/A"
            }
            return variable;
        },
        facebookShare() {
            let url = window.location.href;
            window.open('https://www.facebook.com/sharer/sharer.php?u=' + url,
                'facebook-share-dialog',
                'width=1024,height=768'
            );
            return false;
        }
    },
    computed: {
        computedFields() {
            // If the user isn't an admin, filter out fields that require auth.
            if (typeof this.listingLocal.commission === 'undefined' || this.listingLocal.commission === null) {
                //remove key 'Cooperating Commission' from the items array
                delete this.items[0]['Cooperating Commission'];
            }

            return this.items;
        },
        card_title() {
            if (this.listingLocal.agent !== null) {
                return this.listingLocal.agent.user.name
            } else {
                return "Forman, Jones & Associates Realtors"
            }
        },
        subtitle() {
            if (this.listingLocal.agent !== null) {
                return this.listingLocal.agent.phone;
            } else {
                return "502-412-9400"
            }
        },
        image_array() {
            return $.map(this.listingLocal.images, function (image) {
                return {
                    src: image.Uri800,
                    caption: image.Caption,
                    id: image.Id,
                    thumbnail: image.Uri300
                };
            });
        },
        items() {
            return [
                {
                    'List Price': this.formatCurrency(this.listingLocal.CurrentPrice),
                    'Status': this.listingLocal.MlsStatus,
                    'Property Type': this.listingLocal.PropertySubType,
                    'Beds': this.formatNA(this.listingLocal.BedsTotal),
                    'Bathrooms Total': this.formatNA(this.listingLocal.BathsTotal),
                    'Bathrooms Half': this.formatNA(this.listingLocal.BathsHalf),
                    'Neighborhood': this.listingLocal.MLSAreaMajor,
                    'Subdivision Name': this.listingLocal.SubdivisionName,
                    'Living Area': this.formatNA(this.listingLocal.LivingArea),
                    'Year Built': this.formatNA(this.listingLocal.YearBuilt),
                    'Architectural Style': this.architectural_style,
                    'Days on Market': this.listingLocal.daysOnMarket,
                    'Cooperating Commission': this.listingLocal.commission + '%',
                }
            ];
        },
        placeholder() {
            return "Tell me more about " + this.listingLocal.UnparsedAddress
        },
        estimated_cost() {
            let interest = 4.46;
            let down = this.listingLocal.CurrentPrice * 0.20;

            let loan = this.listingLocal.CurrentPrice - down;

            let rate = (interest / 100) / 12;

            let month = 30 * 12;
            let payment = Math.floor((loan * rate / (1 - Math.pow(1 + rate, (-1 * month)))) * 100) / 100;
            return Math.ceil(payment);
        },
        architectural_style() {
            return Object.keys(this.listingLocal.ArchitecturalStyle)[0];
        }
    },
    mounted() {
        this.$eventHub.$on('mailer::sent', this.mail_sent);
    },
}
</script>

<style lang="scss">
.no-border {
    border: 0;
}

.icon-group {
    display: inline-block;
}

.table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
    text-align: left
}

.card {
    height: 100%;
    width: 100%;
}

.force-center {
    text-align: center !important;
}

.border-3 {
    border-width: 3px !important;
}

i:hover:before {
    height: 42px;
    color: deeppink;
}

.VueCarousel-navigation {
    padding: 0;
}

.top-left {
    position: absolute;
    top: 5px;
    left: 20px;
    z-index: 2;
    color: black;
    background: rgba(255, 255, 255, 0.7);
    padding: 5px;
}
</style>
